import { useEffect, useState } from 'react';
import { getAllNotices } from '../../../services/noticeService';
import { getAllFAQs } from '../../../services/faqService';

export const useDashboardAuxData = () => {
  const [activeNoticesCount, setActiveNoticesCount] = useState(0);
  const [activeFaqsCount, setActiveFaqsCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      getAllNotices({ activeOnly: true }).catch(() => []),
      getAllFAQs({ activeOnly: true }).catch(() => []),
    ]).then(([notices, faqs]) => {
      setActiveNoticesCount(notices.length);
      setActiveFaqsCount(faqs.length);
      setLoading(false);
    });
  }, []);

  return { activeNoticesCount, activeFaqsCount, loading };
};
